<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="剧本名称" prop="scriptName" >
        <a-button type="dashed" @click="showBindScript" danger v-if="form.scriptName">
          <span>{{ form.scriptName }}</span>
        </a-button>
        <a-button type="dashed" @click="showBindScript" danger v-if="!form.scriptName">
          <span style="color: dodgerblue"> 绑定剧本</span>
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="物料类型" prop="type" >
        <a-select v-model="form.type" placeholder="请选择物料类型" @change="changeType" allow-clear>
          <a-select-option :value="1">海报</a-select-option>
          <a-select-option :value="2">文案</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="物料内容" prop="content" v-if="form.type">
        <!--  <editor v-model="form.content" />  -->
        <oss-multi-upload
          v-if="form.type === 1"
          v-model="form.content"
          type="img"
          bucket="played/shop/material"
          :maxCount="1"
          :isMultiple="false"
        ></oss-multi-upload>
        <a-textarea v-if="form.type === 2" v-model="form.content" placeholder="请输入物料内容" :rows="4" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort" >
        <a-input v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="是否启用" prop="isActive" >
        <a-select v-model="form.isActive" placeholder="请选择是否启用" allow-clear>
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>

    <index-script-modal
      ref="IndexScriptModal"
      :isPlayedScript="true"
      @select="indexScriptModalSelect"
      @selectName="indexScriptModalName"
    ></index-script-modal>
  </a-drawer>
</template>

<script>
import { getScriptMaterial, addScriptMaterial, updateScriptMaterial } from '@/api/played/scriptMaterial'
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssMultiUpload,
    IndexScriptModal
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        scriptId: null,
        scriptName: null,
        type: undefined,
        content: null,
        sort: null,
        isActive: undefined
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // scriptId: [
        //   { required: true, message: '剧本ID不能为空', trigger: 'blur' }
        // ],
        scriptName: [
          { required: true, message: '请选择剧本名称', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择物料类型', trigger: 'change' }
        ],
        content: [
          { required: true, message: '物料内容不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        isActive: [
          { required: true, message: '请选择是否启用', trigger: 'blur' }
        ]
        // isDeleted: [
        //   { required: true, message: '逻辑删除标记 1:删除,0:未删除不能为空', trigger: 'blur' }
        // ],
        // remark: [
        //   { required: true, message: '备注不能为空', trigger: 'blur' }
        // ],
        // version: [
        //   { required: true, message: '版本号不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    indexScriptModalSelect(ids) {
      this.form.scriptId = ids
      console.log('获取到的ids', ids)
    },
    indexScriptModalName(name) {
      this.form.scriptName = name
      console.log('获取到的剧本名', name)
    },
    showBindScript: function() {
      this.$refs.IndexScriptModal.open()
    },
    changeType (val) {
      // 判断是否真的发生了变化
      const hasChanged = this.previousType !== val

      if (hasChanged) {
        this.form.content = null // 清空内容
        this.previousType = val // 更新保存的上次值
      }
      console.log('previousType', val)
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        scriptId: null,
        scriptName: null,
        type: undefined,
        content: null,
        sort: null,
        isActive: undefined
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getScriptMaterial(id).then(response => {
        this.form = response.data
        this.previousType = null
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateScriptMaterial(this.form).then(() => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addScriptMaterial(this.form).then(() => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
